import React from 'react';
import PropTypes from 'prop-types';
import { Container, List } from '@pella/sash-framework';
import { classNames } from '@pella/sash-framework/dist/utilities';
import { CTA, Image } from '../../';

const Hero = ({ data, className, children, type, ...other }) => {
	const heroClasses = classNames({
		'palHero': true,
		'py-12 xl:py-16': !data?.image?.[0],
		'md:grid md:grid-cols-1 md:grid-rows-1 md:items-center md:[&>*]:col-start-1 md:[&>*]:row-start-1': data?.image?.[0],
		'text-white [&_h1]:text-white': data.background_hex_value === '#004990',
		'text-black': data.background_hex_value !== '#004990',
		[className]: className,
	});

	return (
		<div
			className={heroClasses}
			style={{ backgroundColor: data.background_hex_value }}
			{...other}
		>
			{data.image?.[0] && (
				<Image
					data={data.image[0]}
					className='palHero-image ml-auto aspect-[3/1] w-full md:h-[345px] md:w-7/12 lg:h-[445px] 2xl:h-[500px]'
					loading='eager'
				/>
			)}

			<Container>
				<div className={`palHero-content ${data?.image?.[0] ? 'pt-6 text-center md:w-4/12 md:pt-0 md:text-left' : ''}`}>
					{data.heading && <h1 className='font-bold'>{data.heading}</h1>}
					{data.subheading && (
						<div
							className='mt-4'
							dangerouslySetInnerHTML={{ __html: data.subheading }}
						/>
					)}
					{data.cta?.[0] && (
						<List
							bullets='none'
							className='mt-6 space-y-4'
						>
							{data.cta.map((cta, index) => (
								<li key={index}>
									<CTA data={cta} />
								</li>
							))}
						</List>
					)}
					{children}
				</div>
			</Container>
		</div>
	);
};

Hero.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
	children: PropTypes.node,
	type: PropTypes.string,
};

export default Hero;
